const purchaseHistoryES = {
    "view": {
        "table": {
            "title": "Tu historial de compras",
            "column": {
                "amount": "Cantidad",
                "description": "Descripción",
                "credits_balance": "Saldo de Créditos",
                "tokens_balance": "Saldo de Tokens",
                "date_of_purchase": "Fecha de Compra",
                "receipt": "Recibo"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "view": "Ver",
                "export_csv": "Exportar CSV"
            }
        }
    }
};

export default purchaseHistoryES;